const deleteFeatureFlags = {
  toastr: 'Updated tenant',
  toastr1: ' has been updated successfully',
  toastrError: 'Index not found'
};

export default deleteFeatureFlags;
